/* ===== Подключение картинок ===== */
import imgFon from "../../assets/images/hero_block.png";

const heroCards = {
  id: "hero-cards",
  // title: "Почему мы",
  // subtitle: "4 причины выбрать нас",
  grid: {
    cols: { base: 1, sm: 2, lg: 2 }, // сетка сама подстроится
    gap: "var(--spacing-4)",
  },

  items: [
    {
      id: "simple-1",
      type: "simple", // заголовок + текст
      title: "Зальём прямо в бак",
      text: "Доставка топлива напрямую в ёмкости или технику без переливов и посредников.",
    },
    {
      id: "simple-2",
      type: "simple", // заголовок + текст
      title: "Всегда на связи",
      text: "Сопровождаем до и после доставки. Быстро решаем любые вопросы.",
    },
    {
      id: "simple-3",
      type: "simple", // заголовок + текст
      title: "Работаем с НДС",
      text: "Договор и полный комплект документов.",
    },
    {
      id: "simple-4",
      type: "simple", // заголовок + текст
      title: "Качество подтверждено",
      text: "Покажем пробы, паспорта и сертификаты на топливо.",
    },
    // {
    //   id: "icon-1",
    //   type: "icon", // иконка + заголовок + текст + кнопка
    //   icon: "⚡",
    //   badge: "Популярное",
    //   title: "Без сюрпризов",
    //   text: "Цену и условия фиксируем заранее. Никаких скрытых доплат.",
    //   button: { label: "Оставить заявку", href: "#form" },
    // },
    // {
    //   id: "media-1",
    //   type: "media", // картинка + заголовок + текст + цена + кнопка
    //   image: { src: imgFon , alt: "Акция" },
    //   overlay: true,
    //   title: "Дизель с доставкой",
    //   text: "Контроль качества и доставка в удобное время.",
    //   price: "от 56 ₽/л",
    //   button: { label: "Заказать", href: "#order" },
    // },
  ],
};


export default heroCards;